import React from 'react';
import ReactDOM from 'react-dom';
import MstAnalytics from 'mst-analytics';
import '~/assets/styles/common.scss';
import PrivacyPolicyNew from '../../components/pages/privacypolicyNew';

ReactDOM.render(
  <PrivacyPolicyNew />,
  document.getElementById('mst-app'),
);

MstAnalytics.init({
  appKey: 'wg22vlfgaqtfqywspolipkqt',
  // dev: true,
  pageConfig: {},
});

MstAnalytics.separatelyReport('ewt_h5_base_public_privacy_policy_ewt360_view');



// WEBPACK FOOTER //
// ./src/entries/privacypolicyNew/privacypolicyNew.jsx